$(document).ready(function(e) {
	// Move to Exon Pixel
	// $(".btn_scorall").click(function() {
	// 	$('html, body').animate({
	// 		scrollTop: $("#getOrder").offset().top - 50
	// 	}, 2000);
	// });
	
	$('.package_slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		asNavFor: '.package_slider_nav',
		autoplay: false,
		autoplaySpeed: 11000,
		dots: false,
	});

	$('.package_slider_nav').slick({
		slidesToShow:5,
		slidesToScroll: 1,
		asNavFor: '.package_slider',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		infinite: true,
		arrows: false,
		rtl: false,
		responsive: [
			{
				breakpoint: 1021,
				settings: {
				slidesToShow:4,
			  }
			},
			
			{
				breakpoint: 767,
				settings: {
				slidesToShow:5,
			  }
			},
		] 
	});		
		
	$('.review_slide_row').slick({
		dots: true,
		slidesToShow:6,
		slidesToScroll: 1,
		adaptiveHeight: false,
		variableWidth: false,
		centerMode: false,
		arrows:false,
		autoplay: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
				slidesToShow:4,
			  }
			},
			{
				breakpoint: 1021,
				settings: {
				slidesToShow:3,
			  }
			},
			
			{
				breakpoint: 767,
				settings: {
				slidesToShow:1,
			  }
			},
		] 
	});
			
	//accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	
	
	var video = $('#myVdo video')[0];
	
	$('.ugc1').click(function(e) {
		$('.ugc-modal').addClass('active');
		$('.video-container').show();
		
		var videoFile = $(this).attr('data-vdo');
		video.src = videoFile;
		video.load();
		video.play();
    });	
	
	$('.ugc-close, .ugc-modal').click(function(e) {
		video.src = '';
       	$('.ugc-modal').removeClass('active');
	   	$('.video-container').hide();
    });
	
	
	$('.s2_looks_wrap').slick({
		dots: false,
		slidesToShow:5,
		slidesToScroll: 1,
		arrows:false,
		autoplay: false,
		responsive: [
			{
				breakpoint: 9999,
				settings: "unslick"
			},
			
			
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow:1,
				variableWidth: true,
				centerMode: true,
			  }
			},
		] 
	});
	
});
	
$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
});

document.addEventListener('DOMContentLoaded', function () {
    const pack1Radio = document.getElementById('buy-pack1');
    const pack2Radio = document.getElementById('buy-pack2');
    const pack1Button = document.querySelector('.j-go.--pack1');
    const pack2Button = document.querySelector('.j-go.--pack2');
    const price1Text = document.querySelector('.s9_price.--pack1');
    const price2Text = document.querySelector('.s9_price.--pack2');

    function toggleButtons() {
        if (pack1Radio.checked) {
            pack1Button.style.display = 'inline-block';
            price1Text.style.display = 'inline-block';
            pack2Button.style.display = 'none';
            price2Text.style.display = 'none';
        } else if (pack2Radio.checked) {
            pack1Button.style.display = 'none';
            price1Text.style.display = 'none';
            pack2Button.style.display = 'inline-block';
            price2Text.style.display = 'inline-block';
        }
    }

    // Run on load
    toggleButtons();

    // Add event listeners
    pack1Radio.addEventListener('change', toggleButtons);
    pack2Radio.addEventListener('change', toggleButtons);
});


document.addEventListener('DOMContentLoaded', function() {
    let trackingFired = false;

    function trackPageView() {
        if (!trackingFired) {
			axon("track", "view_item", {
            	"currency": "USD",
            	"items": [
					{
						"price": "169.97",
						"item_name": "6-in-1 Hot Air Styler",
						"item_id": "9209418613055",
                        "item_variant_id": "50124658049343",
						"item_category_id": "469", // From Axon List 
						"quantity": "1",
						"image_url": "https://cdn.shopify.com/s/files/1/0684/7974/6367/files/Air_Styler_B0CN3XNVJT_Black_Amazon_Main_Image_Sept_2025.jpg?v=1760435644",
					}
				]
        		});
            console.log('Page view tracked adjusted');
            trackingFired = true;
        }
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                trackPageView();
            }
        });
    }, {
        threshold: 0.05
    });

    const getOrderElement = document.getElementById('getOrder');
    if (getOrderElement) {
        observer.observe(getOrderElement);
    }

    $(".btn_scorall").click(function() {
        $('html, body').animate({
            scrollTop: $("#getOrder").offset().top - 60
        }, 2000, function() {

            trackPageView();

        });
    });

    
    if (getOrderElement && getOrderElement.getBoundingClientRect().top < window.innerHeight) {
        trackPageView();
    }
});

function createOrSyncCookies() {
	const primaryCookieName = 'axwrt';   // This is the main cookie we'll sync others to.
	const secondaryCookieName = '_axwrt'; // Axon Cookie
	let userId = getCookieValue(primaryCookieName) || getCookieValue(secondaryCookieName) || generateUserId(); // Use existing or generate new.

	// Sync both cookies - set the same userId
	setCookie(primaryCookieName, userId, 365, '/');
	setCookie(secondaryCookieName, userId, 365, '/');

	console.log('Cookies synchronized with UserId:', userId);
}

function generateUserId() {
	return 'uid_' + Math.random().toString(36).substr(2, 9);
}

function getCookieValue(cookieName) {
	var name = cookieName + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i].trim();
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return null;
}

function setCookie(name, value, days, path) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=" + path;
}

createOrSyncCookies();